const nutrientMapping = [
    // SDK path (AI scan, barcode) where numeric nutrient IDs are unavailable.
    { passioKey: "calories", fdcNutrientId: 1008 },
    { passioKey: "carbs", fdcNutrientId: 1005 },
    { passioKey: "protein", fdcNutrientId: 1003 },
    { passioKey: "fat", fdcNutrientId: 1004 },
    // Micros
    { passioKey: "satFat", fdcNutrientId: 1258 },
    { passioKey: "transFat", fdcNutrientId: 1257 },
    { passioKey: "cholesterol", fdcNutrientId: 1253 },
    { passioKey: "sodium", fdcNutrientId: 1093 },
    { passioKey: "fibers", fdcNutrientId: 1079 },
    { passioKey: "sugars", fdcNutrientId: 2000 },
    { passioKey: "sugarsAdded", fdcNutrientId: 1235 },
    { passioKey: "vitaminD", fdcNutrientId: 1114 },
    { passioKey: "calcium", fdcNutrientId: 1087 },
    { passioKey: "iron", fdcNutrientId: 1089 },
    { passioKey: "potassium", fdcNutrientId: 1092 },
    { passioKey: "vitaminA", fdcNutrientId: 1104 },
    { passioKey: "vitaminC", fdcNutrientId: 1162 },
    { passioKey: "vitaminE", fdcNutrientId: 1109 },
    { passioKey: "vitaminB6", fdcNutrientId: 1175 },
    { passioKey: "vitaminB12", fdcNutrientId: 1178 },
    { passioKey: "magnesium", fdcNutrientId: 1090 },
    { passioKey: "phosphorus", fdcNutrientId: 1091 },
    { passioKey: "iodine", fdcNutrientId: 1100 },
    { passioKey: "monounsaturatedFat", fdcNutrientId: 1292 },
    { passioKey: "polyunsaturatedFat", fdcNutrientId: 1293 },
    { passioKey: "alcohol", fdcNutrientId: 1018 },
    { passioKey: "sugarAlcohol", fdcNutrientId: 1086 },
    { passioKey: "zinc", fdcNutrientId: 1095 },
    { passioKey: "selenium", fdcNutrientId: 1103 },
    { passioKey: "folicAcid", fdcNutrientId: 1186 },
    { passioKey: "vitaminKPhylloquinone", fdcNutrientId: 1185 },
    { passioKey: "vitaminKMenaquinone4", fdcNutrientId: 1184 },
    { passioKey: "vitaminKDihydrophylloquinone", fdcNutrientId: 1183 },
    { passioKey: "chromium", fdcNutrientId: 1096 },
    { passioKey: "vitaminARAE", fdcNutrientId: 1106 },
    { passioKey: "vitaminB12Added", fdcNutrientId: 1246 },
    { passioKey: "vitaminEAdded", fdcNutrientId: 1242 },
    { passioKey: "thiamin", fdcNutrientId: 1165 },
    { passioKey: "riboflavin", fdcNutrientId: 1166 },
    { passioKey: "niacin", fdcNutrientId: 1167 },
    { passioKey: "pantothenicAcid", fdcNutrientId: 1170 },
    { passioKey: "folateTotal", fdcNutrientId: 1177 },
    { passioKey: "folateDFE", fdcNutrientId: 1190 },
    { passioKey: "choline", fdcNutrientId: 1180 },
    { passioKey: "copper", fdcNutrientId: 1098 },
    { passioKey: "manganese", fdcNutrientId: 1101 },
    { passioKey: "caroteneBeta", fdcNutrientId: 1107 },
    { passioKey: "luteinZeaxanthin", fdcNutrientId: 1123 },
];
/**
 * Maps SDK-style named PassioNutrients keys (e.g. "sodium", "vitaminC") to FDC nutrient IDs.
 * Used by the REST parser to convert `nutrients_reference` / SDK-shaped nutrient objects
 * to FDC-ID-keyed amounts
 */
export const PASSIO_SDK_KEY_TO_FDC_ID = Object.fromEntries(nutrientMapping.map(m => [m.passioKey, m.fdcNutrientId]));
/**
 * Maps SDK-style named PassioNutrients keys to FDC-ID-keyed amounts.
 * Used by the mobile SDK path (AI scan, barcode) where numeric nutrient IDs are unavailable.
 * todo: @see NUT-2225 — future: replace with addPassioFoodByRefCode for full nutrient coverage.
 */
export const mapPassioSdkNutrientsToFdcAmounts = (passioNutrients, selectedQuantity = 1) => {
    if (!passioNutrients)
        return [];
    const quantity = selectedQuantity || 1;
    return nutrientMapping.flatMap(({ passioKey, fdcNutrientId }) => {
        const value = passioNutrients[passioKey]?.value;
        return value != null ? [{ fdcNutrientId, amount: value / quantity }] : [];
    });
};
//# sourceMappingURL=nutrients.js.map